import type { QueryRowType } from "@rocicorp/zero";
import { useQuery, useZero } from "@rocicorp/zero/react";
import { sharedMutators } from "../../../shared/mutators";
import { queries } from "../../../shared/queries";
import { PersonalUseCard } from "../PersonalUseCard";
import { skillRoleDefaultsForSpace } from "../../lib/skillGrantsForSpace";
import type { ScopeAccessPendingHandle } from "../ScopeAccessTable";
import { SupplierAccessTab } from "../SupplierAccessTab";

type Skill = NonNullable<QueryRowType<ReturnType<typeof queries.loadSkill>>>;

type Props = {
  skill: Skill;
  canManage: boolean;
  onEdit?: () => void;
  stagedGrantsRef?: { current: ScopeAccessPendingHandle | null };
};

export function SkillAccessTab({
  skill,
  canManage,
  onEdit,
  stagedGrantsRef,
}: Props) {
  const z = useZero();
  const [groupAccess] = useQuery(
    queries.skillGroupAccess({ skillId: skill.id })
  );
  return (
    <SupplierAccessTab
      scopeId={skill.id}
      scopeKind="skill"
      scopeGrants={skill.roleGrantsAsScope}
      supplierRelation="space_uses_skills"
      roleDefaultsForSpace={skillRoleDefaultsForSpace}
      resourceLabel="skill"
      accessDescription="Add members, groups, or a whole space, and choose their role."
      groupAccess={groupAccess}
      canManage={canManage}
      onEdit={onEdit}
      stagedGrantsRef={stagedGrantsRef}
    >
      <PersonalUseCard
        resourceLabel="skill"
        personalUse={skill.personalUse}
        canManage={canManage}
        onChange={(personalUse) =>
          z.mutate(
            sharedMutators.setSkillPersonalUse({
              skillId: skill.id,
              personalUse,
            })
          )
        }
      />
    </SupplierAccessTab>
  );
}
